import { render, staticRenderFns } from "./UserInfoTableRow.vue?vue&type=template&id=b5e6d74c&"
import script from "./UserInfoTableRow.vue?vue&type=script&lang=js&"
export * from "./UserInfoTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports